enum InvoiceUrlType {
  PDF = 'PDF',
  HTML = 'HTML',
  OTHER = 'OTHER',
}

export default InvoiceUrlType;
